export default {
    application: {
        contract: "Options Analysis",
        stock: "Stock Analysis",
        more: "More",
    },

    page_title_suffix: " - FSF Options Lab",

    contract: {
        title: "Option Analysis Assistant",
        keywords: "FSF Options Lab",
        description: "Option Analysis Assistant",

        overview: "Market Dashboard",
        realtime: "Live Quotes Tracker",
        history: "Historical Archive",
        analyze: "Contract Insight",
        anomaly: "Anomaly Monitor",
        strategy: "Strategy Lab",
        intelligence: "Intelligence Hub",
        config: "Advanced Configuration",
        calc: "Options Calculator",
    },
};
